import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-logout-message',
  templateUrl: './logout-message.component.html',
  styleUrls: ['./logout-message.component.scss']
})
export class LogoutMessageComponent implements OnInit {
  @Output('closePopup') closePopup = new EventEmitter();
  @Output('logout') logout = new EventEmitter();

  @Input() title:string;
  @Input() contect:HTMLElement;
  constructor() { }

  ngOnInit(): void {
  }

}
